<template>
  <div id="qtgs">
    <div v-for="one in mes">
      <a download :href="one.URL" target="_blank">{{one.TITLE}}</a>
    </div>
    <!--链接失败，重定向到手机端-->
    <!--<div>-->
      <!--<a href="https://www.cesfutures.com/page/zzwd/#/index/ml/cjwt?type=%E8%B5%84%E9%87%91%E5%AD%98%E5%8F%96">东航期货保证金存管账户公示</a>-->
    <!--</div>-->
  </div>
</template>

<script>
import ajax from '@/common/ajax/ajax'

export default {
  name: 'qtgs',
  data: function () {
    return {
      mes: {}
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      ajax.getQTGS().then(
        data => {
          this.mes = data
        }
      )
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  #qtgs
    margin 20px 0
    a
      font-size 1.6rem
      color #2780b0
</style>



// WEBPACK FOOTER //
// qtgs.vue?40461606